import cx from 'classnames'

import { SanityShopPrint } from '@data/sanity/queries/types/shop'

import Photo from '@components/photo'

interface PrintFieldItemProps {
  print: SanityShopPrint
  fieldValue: SanityShopPrint | null
  onPrintClick: (print: SanityShopPrint | null) => void
}

const PrintFieldItem = ({
  print,
  fieldValue,
  onPrintClick,
}: PrintFieldItemProps) => {
  const isSelected = fieldValue && print._key === fieldValue._key

  return (
    <div className="print-slide flex flex-col items-center gap-y-2.5">
      <button
        type="button"
        onClick={() => {
          onPrintClick(print)
        }}
        className={cx('p-2.5 border', {
          'border-gray-light': !isSelected,
          'border-black': isSelected,
        })}
      >
        {!!print.printImage && (
          <div
            className={cx(
              'w-[68px] h-[68px] overflow-hidden flex items-center',
              {
                'bg-black': print.printColor === 'light',
              },
            )}
          >
            <Photo image={print.printImage} />
          </div>
        )}
      </button>

      <p className="w-[90px] leading-tight font-semibold text-sm text-center hyphens-auto">
        {print.title}
      </p>
    </div>
  )
}

export default PrintFieldItem
